import { render, staticRenderFns } from "./MediaServerDetail.vue?vue&type=template&id=7831ff0b"
import script from "./MediaServerDetail.vue?vue&type=script&lang=ts"
export * from "./MediaServerDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports